import Quill from 'quill'
import { getSize } from './tools'
import { getFileIcon } from './tools'

const BlockEmbed = Quill.import('blots/embed')

class FileBlot extends BlockEmbed {
  static create({
    tempId,
    title,
    size,
    type,
    url,
    id,
    text,
    from,
    fileId,
    origin,
  }: IPicBlot) {
    let node = super.create() as HTMLLinkElement

    // insert @/#
    if (type === 'people' || type === 'matter') {
      node.innerText = `${type === 'people' ? '@' : '#'}${text}`
      if (type === 'matter') {
        node.style.color = 'var(--primary)'
      }
      node.style.textDecoration = 'none'
      node.setAttribute('type', type)
      node.setAttribute('data-id', id)
      node.href = `type=${type}&id=${id}`
      return node
    }

    // insert file/img
    node.classList.add('blot-pic')
    node.classList.add('blot-common')
    node.setAttribute('data-tempid', tempId + '')
    node.setAttribute('type', type)
    node.setAttribute('data-origin', origin || '')
    node.id = `blot_${tempId}`

    const commonQuery = `type=${type}&title=${title}&size=${size}&uniId=${node.id}`
    node.href = `${commonQuery}&id=hrefId-${tempId}`

    const loadingDom = `<image class="loading" src="./images/loading.gif"></image>`

    const isFlyDoc = from === 'flyDoc'

    if (isFlyDoc) {
      node.setAttribute('data-file', fileId)
      node.setAttribute(
        'data-origin',
        window.localStorage.getItem('file_origin') as string
      )
      node.href = `${commonQuery}&id=${fileId}`
    }

    if (type === 'img') {
      // img
      node.classList.add('blot-common_img')
      node.style.backgroundImage = `url(${url})`
      if (!isFlyDoc) {
        node.innerHTML = `
          <div class="mask"></div>
          ${loadingDom}
        `
      }
    } else {
      // file
      node.setAttribute('data-title', title)
      node.innerHTML = `
        <img class="bg-file" src="${getFileIcon(
          title.split('.').pop() as string,
          isFlyDoc
        )}"></img>
        <span class="info" ${isFlyDoc ? 'style="color: white"' : ''}>
          <span class="title">${title}</span>
          <span class="size">${getSize(size)}</span>
        </span>
        ${isFlyDoc ? '' : loadingDom}
      `
    }

    return node
  }

  static value(node: HTMLDivElement) {
    return {
      type: node.getAttribute('type'),
      tempId: node.getAttribute('data-tempid'),
      fileId: node.getAttribute('data-file'),
      userId: node.getAttribute('data-id'),
      text: node.innerText,
      origin: node.getAttribute('data-origin'),
      title: node.getAttribute('data-title'),
    }
  }
}

FileBlot.blotName = 'INSERT_FILE'
FileBlot.tagName = 'a'
Quill.register(FileBlot)
